import {
    IDENTIFY_SET_LOADING,
    // IDENTIFY_RECORD_LIST_LOADED,
    IDENTIFY_CHANGE_PAGE,
    IDENTIFY_NEW_REQUEST,
    IDENTIFY_PURGE_RESULTS,
    IDENTIFY_EXCEPTIONS_FEATURE_INFO,
    IDENTIFY_LOAD_FEATURE_INFO,
    IDENTIFY_ERROR_FEATURE_INFO,
} from './IdentifyActions';

export default {
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {
        dispatchIdentifyAction(params){
            this.$store.dispatch('identifyAction', {'idModule': this.moduleCode, ...params});
        },
        setLoading(loading = false) {
            this.dispatchIdentifyAction({
                type: IDENTIFY_SET_LOADING,
                loading
            });
        },
        changePage(index) {
            this.dispatchIdentifyAction({
                type: IDENTIFY_CHANGE_PAGE,
                index
            });
        },
        // recordsLoaded(options, result) {
        //     this.dispatchIdentifyAction({
        //         type: IDENTIFY_RECORD_LIST_LOADED,
        //         infoOptions: options,
        //         result: result,
        //     });
        // },
        // recordsLoadError(e) {
        //     this.dispatchIdentifyAction({
        //         type: IDENTIFY_RECORD_LIST_LOAD_ERROR,
        //         error: e
        //     });
        // },
        newMapInfoRequest(reqId, reqConfig) {
            this.dispatchIdentifyAction({
                type: IDENTIFY_NEW_REQUEST,
                reqId: reqId,
                request: reqConfig
            });
        },
        purgeResults() {
            this.dispatchIdentifyAction({
                type: IDENTIFY_PURGE_RESULTS,
            });
        },
        noQueryableLayers() {
            this.showWarning('Nenhuma camada pesquisável ativa');
        },
        loadFeatureInfo(reqId, data, rParams, lMetaData, layer) {
            this.dispatchIdentifyAction({
                type: IDENTIFY_LOAD_FEATURE_INFO,
                data: data,
                reqId: reqId,
                requestParams: rParams,
                layerMetadata: lMetaData,
                layer
            });
        },
        exceptionsFeatureInfo(reqId, exceptions, rParams, lMetaData) {
            this.dispatchIdentifyAction({
                type: IDENTIFY_EXCEPTIONS_FEATURE_INFO,
                reqId: reqId,
                exceptions: exceptions,
                requestParams: rParams,
                layerMetadata: lMetaData
            });
        },
        errorFeatureInfo(reqId, error, rParams, lMetaData) {
            this.dispatchIdentifyAction({
                type: IDENTIFY_ERROR_FEATURE_INFO,
                error: error,
                reqId: reqId,
                requestParams: rParams,
                layerMetadata: lMetaData
            });
        }

    },
};